export default __webpack_public_path__ + "static/media/hospital.c8db7feb.jpg";